<div class="sidebar" [class.collapsed]="estaColapsado">

  <button class="toggle-button" 
          type="button"
          aria-label="Alternar menú"
          (click)="alternarColapso()">
      <span class="btn-nav" [class.hidden]="estaColapsado" aria-label="Anterior">
        <i class="pi pi-chevron-left"></i>
      </span>

      <span class="btn-nav" [class.hidden]="!estaColapsado" aria-label="Siguiente">
        <i class="pi pi-chevron-right"></i>
      </span>
  </button>

  <ul class="menu-items">
    @for (elemento of elementosMenu; track elemento.titulo) {
      <li class="menu-item"
          [class.has-submenu]="elemento.hijos && elemento.hijos.length"
          (mouseenter)="alEntrarRaton(elemento, $event)"
          (mouseleave)="alSalirRaton()">
        <button class="menu-link"
                [class.active]="elemento.ruta && esRutaActiva(elemento.ruta)"
                type="button"
                (click)="elemento.ruta ? navegarA(elemento.ruta) : alternarSubmenu(elemento)">
          <i class="pi {{ elemento.icono }}" aria-hidden="false" aria-label="Icono del menú"></i>
          @if (!estaColapsado || (estaColapsado && elemento.mostrarEnHover)) {
            <span class="title">
              {{ elemento.titulo }}
            </span>
          }
          @if (elemento.hijos && elemento.hijos.length && !estaColapsado) {
            <span class="arrow">
              <i class="pi pi-chevron-down" [class.hidden]="elemento.expandido"></i>
              <i class="pi pi-chevron-up" [class.hidden]="!elemento.expandido"></i>
            </span>
          }
        </button>

        @if (elemento.hijos && elemento.hijos.length && (elemento.expandido || (estaColapsado && elemento.mostrarEnHover))) {
          <ul class="submenu"
              [class.show-on-hover]="estaColapsado && elemento.mostrarEnHover">
            @for (subElemento of elemento.hijos; track subElemento.ruta) {
              <li class="submenu-item">
                <button class="submenu-link"
                        [class.active]="subElemento.ruta && esRutaActiva(subElemento.ruta!)"
                        type="button"
                        (click)="navegarA(subElemento.ruta!)">
                  <span>{{ subElemento.titulo }}</span>
                  @if (debeMostrarBadge(subElemento)) {
                    <span class="badge-count">{{ getBadgeCount(subElemento.ruta!) }}</span>
                  }
                </button>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>

  @if (mostrarCambiarRolEmpresa) {
    <div class="menu-footer">
      <button class="menu-footer__item"
              type="button"
              aria-label="Cambiar rol y organización"
              (click)="cambiarRolOrganizacion()">
        <div class="menu-footer__icono">
          <i class="pi pi-sync"></i>
        </div>
        <span class="menu-footer__texto" [class.hidden]="estaColapsado">Cambiar rol/empresa</span>
      </button>
    </div>
  }
</div>

<ng-template #popoverTemplate let-elemento="elemento">
  <div class="menu-popover" 
       (mouseenter)="onPopoverMouseEnter()" 
       (mouseleave)="onPopoverMouseLeave()">
    @if (elemento.hijos && elemento.hijos.length) {
      <div class="popover-options">
        @for (hijo of elemento.hijos; track hijo.titulo) {
          <button class="popover-option"
                  type="button"
                  (click)="navegarDesdePopover(hijo.ruta!)"
                  (keydown)="onPopoverOptionKeyDown($event, hijo.ruta!)"
                  [attr.aria-label]="hijo.titulo">
            <div class="option-content">
              <div class="option-title">{{ hijo.titulo }}</div>
              @if (debeMostrarBadge(hijo)) {
                <span class="badge-count">{{ getBadgeCount(hijo.ruta!) }}</span>
              }
            </div>
          </button>
        }
      </div>
    }
  </div>
</ng-template>
